<template>
  <div class="animated fadeIn">
    <loader
     :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ titulo }} </strong>
          </div>
          <b-row>
            <b-col md="12">
                 <b-form-select v-model="selected" @change="cambiaArea" :options="select" class="mb-3" />
            </b-col>
            <b-col md="6" v-for="(element, index) in subAreas.subArea"
              :key="index">
                  <b-list-group>
                      <b-list-group-item variant="secondary" class="d-flex justify-content-between align-items-center">
                      <h5>{{element.nombre}}</h5>
                      </b-list-group-item>
                <b-form-checkbox-group v-model="checked">
                      <b-list-group-item v-for="(item, index) in element.permisos"
                          :key="index">
                          <b-form-checkbox @change="guardaPermiso(item._id)" :value="item._id">
                            {{item.numero}} - {{item.nombre}}
                          </b-form-checkbox>
                      </b-list-group-item>
                </b-form-checkbox-group>
                  </b-list-group>
            </b-col>
            
            <b-col md="12" class="text-left">
              <br>
              <b-button 
                @click="regresar()"
                size="sm" 
                variant="secondary"
                >
                Regresar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>

import cTable from '../base/Table.vue'
import axios from 'axios'
import { required, minLength, email } from 'vuelidate/lib/validators'
import Loader from '../Loader'
import path from 'path'

import { mapGetters } from "vuex";


export default {
  name: 'permisosUsuario',
  components: {Loader},
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ])
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      usuario: {laboral:{}},
      permisosIndex: [],
      permisosUsuario: [],
      subAreas: [],
      select:[],
      selected: {},
      checked: []
    }
  }, 
  created() {
    this.enviando = true;
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 108) < 0 )
        this.$router.go(-1);
      else{
        axios.get(this.httpURL+'/usuarios/'+this.$route.params.id+'/permisos',{headers:{token:this.sessionToken}})
              .then(res => {
                  //console.log(res.data);
                  this.permisosIndex = res.data.permisosIndex;
                  this.permisosUsuario = res.data.permisosUsuario;
                  this.subAreas = this.permisosIndex[0];
                  this.permisosIndex.forEach(element => {
                        this.select.push({value:element._id,text:element.area});
                    });
                  this.selected = this.select[0].value;
                  this.permisosUsuario.permisos.forEach(element => {
                    this.checked.push(element._id);
                  });
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
      }
  },
  methods: {
    cambiaArea(id){
      this.permisosIndex.forEach(element => {
            if( element._id == id )
                this.subAreas = element;
        });
    },
    guardaPermiso(id){
      this.enviando = true;
      //console.log('area: '+this.area+' subarea: '+subarea);
      axios.post(this.httpURL+'/usuarios/'+this.$route.params.id+'/permisos',
            {permiso:id},
            {headers: {token:this.sessionToken}})
        .then(res => {
            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                text: 'Permiso modificado correctamente.' });
            this.enviando = false;
        })
        .catch(error => {
            //console.log(error);
            this.enviando = false;
            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                text: 'Ocurrió un error al modificar el permiso.' });
        });
    },
    regresar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
.text-error {
    color: #FFFFFF;
}
.invalid_input{
    border: 1px solid red;
}
.vue-notification {
  font-size: 14px;
}
</style>
